import { render, staticRenderFns } from "./DocTpl.vue?vue&type=template&id=61911c6c&scoped=true&"
import script from "./DocTpl.vue?vue&type=script&lang=js&"
export * from "./DocTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61911c6c",
  null
  
)

export default component.exports